












































































import Vue from "vue";

import { Auth, setLocale, SupportedLocales, apiStats } from "@/@core";
import DynamicToolbar from "@/@shell/components/BaseToolbar/Index.vue";
import { ConfigToolbar, MenuToolbar } from "./BaseToolbar/interfaces/ToolbarItem";

export default Vue.extend({
  components: {
    DynamicToolbar,
  },
  props: {
    hideDrawerHandle: {
      type: Boolean,
    },
    menu: {
      type: Array as () => MenuToolbar[],
    },
    config: {
      type: Object as () => ConfigToolbar,
    },
    canLogOut: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      collapseDrawer: false,
      userName: undefined,
      setLocale: setLocale,
      apiStats,
      locales: SupportedLocales,
      appLogo: `${process.env.BASE_URL}img/logo-white.svg`,
      headerSize: 0,
    };
  },
  computed: {
    showDrawer(): boolean {
      return !!(this.$scopedSlots.drawer || this.$slots.drawer);
    },
  },
  created() {
    window.addEventListener("resize", this.refreshHeader);
  },
  destroyed() {
    window.removeEventListener("resize", this.refreshHeader);
  },
  updated() {
    this.refreshHeader();
  },
  async mounted() {
    this.refreshHeader();
    this.userName = await Auth.getClaim("given_name");
  },
  methods: {
    logOut() {
      Auth.logOut();
    },
    refreshHeader() {
      this.headerSize =
        (document.getElementById("toolbar")?.clientHeight || 0) +
        (document.getElementById("header")?.clientHeight || 0) +
        1;
    },
  },
});
